// import React, { useState } from "react";
// import "./App.css";

// function App() {
//   const [question, setQuestion] = useState("");
//   const [chat, setChat] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const sendMessage = async () => {
//     if (!question.trim()) return;

//     const userMessage = { role: "user", text: question };
//     setChat(prev => [...prev, userMessage]);
//     setLoading(true);

//     try {
//       const response = await fetch("http://localhost:9000/chat", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ question })
//       });

//       const data = await response.json();

//       const botMessage = {
//         role: "bot",
//         text: data.answer || "No response",
//         product_url: data.product_url || null
//       };

//       setChat(prev => [...prev, botMessage]);
//     } catch (error) {
//       setChat(prev => [
//         ...prev,
//         { role: "bot", text: "Server error. Please try again." }
//       ]);
//     }

//     setQuestion("");
//     setLoading(false);
//   };

//   return (
//     <div className="app-container">
//       <div className="chat-card">
//         <div className="chat-header">
//     <img
//       src="/3ab1a470-526e-41c6-b105-c495834803c6.png"  
//       alt="Aiyo Logo"
//       className="logo"
//     />
//     <h2>Aiyo Event AI Assistant</h2>
//   </div>
//         <div className="chat-body">
//           {chat.map((msg, index) => (
//             <div
//               key={index}
//               className={msg.role === "user" ? "user-message" : "bot-message"}
//             >
//               <div>{msg.text}</div>

//               {/* Show Buy Button if product link exists */}
//               {msg.product_url && (
//                 <a
//                   href={msg.product_url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="buy-button"
//                 >
//                   View / Buy Now
//                 </a>
//               )}
//             </div>
//           ))}

//           {loading && <div className="bot-message typing">Typing...</div>}
//         </div>

//         <div className="chat-footer">
//           <input
//             value={question}
//             onChange={(e) => setQuestion(e.target.value)}
//             placeholder="Ask about products..."
//             onKeyDown={(e) => e.key === "Enter" && sendMessage()}
//           />
//           <button onClick={sendMessage}>Send</button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default App;




// import React, { useState, useEffect } from "react";
// import "./App.css";

// function App() {
//   const [question, setQuestion] = useState("");
//   const [chat, setChat] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [sessionId, setSessionId] = useState(null);

//   // Load session from localStorage on first load
//   useEffect(() => {
//     const storedSession = localStorage.getItem("session_id");
//     if (storedSession) {
//       setSessionId(storedSession);
//     }
//   }, []);

//   const sendMessage = async () => {
//     if (!question.trim()) return;

//     const userMessage = { role: "user", text: question };
//     setChat(prev => [...prev, userMessage]);
//     setLoading(true);

//     try {
//       const response = await fetch("http://localhost:9000/chat", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           question,
//           session_id: sessionId
//         })
//       });

//       const data = await response.json();

//       // Save session_id from backend
//       if (data.session_id) {
//         localStorage.setItem("session_id", data.session_id);
//         setSessionId(data.session_id);
//       }

//       const botMessage = {
//         role: "bot",
//         text: data.answer || "No response",
//         product_url: data.product_url || null
//       };

//       setChat(prev => [...prev, botMessage]);

//     } catch (error) {
//       setChat(prev => [
//         ...prev,
//         { role: "bot", text: "Server error. Please try again." }
//       ]);
//     }

//     setQuestion("");
//     setLoading(false);
//   };

//   // // 🔥 Start New Chat (Auto Refresh Session)
//   const startNewChat = () => {
//     localStorage.removeItem("session_id");
//     setSessionId(null);
//     setChat([]);
//   };

//   return (
//     <div className="app-container">
//       <div className="chat-card">

//         <div className="chat-header">
//           <img
//             src="/3ab1a470-526e-41c6-b105-c495834803c6.png"
//             alt="Aiyo Logo"
//             className="logo"
//           />
//           <h2>Aiyo Event AI Assistant</h2>

//           {/* New Chat Button */}
//           {/* <button className="new-chat-btn" onClick={startNewChat}>
//             New Chat
//           </button> */}
//         </div>

//         <div className="chat-body">
//           {chat.map((msg, index) => (
//             <div
//               key={index}
//               className={msg.role === "user" ? "user-message" : "bot-message"}
//             >
//               <div>{msg.text}</div>

//               {msg.product_url && (
//                 <a
//                   href={msg.product_url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="buy-button"
//                 >
//                   View / Buy Now
//                 </a>
//               )}
//             </div>
//           ))}

//           {loading && <div className="bot-message typing">Typing...</div>}
//         </div>

//         <div className="chat-footer">
//           <input
//             value={question}
//             onChange={(e) => setQuestion(e.target.value)}
//             placeholder="Ask about products..."
//             onKeyDown={(e) => e.key === "Enter" && sendMessage()}
//           />
//           <button onClick={sendMessage}>Send</button>
//         </div>

//       </div>
//     </div>
//   );
// }

// export default App;

// 2222222222

// import React, { useState, useEffect } from "react";
// import "./App.css";

// function App() {
//   const [question, setQuestion] = useState("");
//   const [chat, setChat] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [sessionId, setSessionId] = useState(null);

//   // Load session
//   useEffect(() => {
//     const storedSession = localStorage.getItem("session_id");
//     if (storedSession) setSessionId(storedSession);
//   }, []);

//   const sendMessage = async () => {
//     if (!question.trim()) return;

//     const userMessage = { role: "user", text: question };
//     setChat(prev => [...prev, userMessage]);
//     setLoading(true);

//     try {
//       const response = await fetch("http://localhost:9000/chat", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ question, session_id: sessionId })
//       });

//       const data = await response.json();

//       if (data.session_id) {
//         localStorage.setItem("session_id", data.session_id);
//         setSessionId(data.session_id);
//       }

//       const botMessage = parsePricesToTables(
//         data.answer || "",
//         data.product_url
//       );

//       setChat(prev => [...prev, botMessage]);

//     } catch (err) {
//       setChat(prev => [
//         ...prev,
//         { role: "bot", text: "Server error. Please try again." }
//       ]);
//     }

//     setQuestion("");
//     setLoading(false);
//   };

//   const startNewChat = () => {
//     localStorage.removeItem("session_id");
//     setSessionId(null);
//     setChat([]);
//   };

//   // ============================================
//   // 🔥 SUPER ROBUST PRICE → TABLE PARSER
//   // ============================================
//   const parsePricesToTables = (text, product_url = null) => {
//     const tables = [];
//     const tableRows = [];
//     const addedRows = new Set();

//     // 1️⃣ Duration / Cups Pattern
//     const durationRegex =
//       /(\d+\s*-?\s*(Hour|Hours|Cup|Cups))[^$\d]*\$?([\d]+(?:\.\d+)?)/gi;

//     let match;
//     while ((match = durationRegex.exec(text)) !== null) {
//       const duration = match[1].trim();
//       const price = match[3].trim();

//       const key = duration + price;
//       if (!addedRows.has(key)) {
//         tableRows.push({
//           Duration: duration,
//           Price: price
//         });
//         addedRows.add(key);
//       }
//     }

//     // 2️⃣ Addon Quantity Pattern
//     const addonRegex =
//       /addon\s+(?:quantity|price)[^$\d]*\$?([\d]+(?:\.\d+)?)/i;

//     const addonMatch = text.match(addonRegex);

//     if (addonMatch) {
//       const price = addonMatch[1].trim();
//       const key = "Addon" + price;

//       if (!addedRows.has(key)) {
//         tableRows.push({
//           Duration: "Addon Quantity",
//           Price: price
//         });
//         addedRows.add(key);
//       }
//     }

//     // 3️⃣ Generic fallback: detect "is 100.00"
//     const simplePriceRegex =
//       /\bis\s+\$?([\d]+(?:\.\d+)?)/gi;

//     while ((match = simplePriceRegex.exec(text)) !== null) {
//       const price = match[1].trim();
//       const key = "Standard" + price;

//       if (!addedRows.has(key) && tableRows.length === 0) {
//         tableRows.push({
//           Duration: "Standard",
//           Price: price
//         });
//         addedRows.add(key);
//       }
//     }

//     if (tableRows.length) tables.push(tableRows);

//     return {
//       role: "bot",
//       text,
//       tables: tables.length ? tables : null,
//       product_url
//     };
//   };

//   return (
//     <div className="app-container">
//       <div className="chat-card">

//         {/* Header */}
//         <div className="chat-header">
//           <img
//             src="/3ab1a470-526e-41c6-b105-c495834803c6.png"
//             alt="Aiyo Logo"
//             className="logo"
//           />
//           <h2>Aiyo Event AI Assistant</h2>
//         </div>

//         {/* Chat Body */}
//         <div className="chat-body">
//           {chat.map((msg, index) => (
//             <div
//               key={index}
//               className={
//                 msg.role === "user"
//                   ? "user-message"
//                   : "bot-message"
//               }
//             >
//               <div>{msg.text}</div>

//               {/* Dynamic Tables */}
//               {msg.tables &&
//                 msg.tables.map((table, tIndex) => (
//                   <table key={tIndex} className="chat-table">
//                     <thead>
//                       <tr>
//                         {Object.keys(table[0]).map((key, i) => (
//                           <th key={i}>{key}</th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {table.map((row, rIndex) => (
//                         <tr key={rIndex}>
//                           {Object.values(row).map((val, cIndex) => (
//                             <td key={cIndex}>{val}</td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 ))}

//               {/* Product Link */}
//               {msg.product_url && (
//                 <a
//                   href={msg.product_url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="buy-button"
//                 >
//                   View / Buy Now
//                 </a>
//               )}
//             </div>
//           ))}

//           {loading && (
//             <div className="bot-message typing">
//               Typing...
//             </div>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="chat-footer">
//           <input
//             value={question}
//             onChange={(e) => setQuestion(e.target.value)}
//             placeholder="Ask about products..."
//             onKeyDown={(e) =>
//               e.key === "Enter" && sendMessage()
//             }
//           />
//           <button onClick={sendMessage}>
//             Send
//           </button>
//         </div>

//       </div>
//     </div>
//   );
// }

// export default App;


// oldddddddddddddd@@@@@@@@@@@@@

// import React, { useState, useEffect } from "react";
// import "./App.css";

// function App() {
//   const [question, setQuestion] = useState("");
//   const [chat, setChat] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [sessionId, setSessionId] = useState(null);

//   // Load session
//   useEffect(() => {
//     const storedSession = localStorage.getItem("session_id");
//     if (storedSession) setSessionId(storedSession);
//   }, []);

//   const sendMessage = async () => {
//     if (!question.trim()) return;

//     const userMessage = { role: "user", text: question };
//     setChat(prev => [...prev, userMessage]);
//     setLoading(true);

//     try {
//       const response = await fetch("http://localhost:9000/chat", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ question, session_id: sessionId })
//       });

//       const data = await response.json();

//       if (data.session_id) {
//         localStorage.setItem("session_id", data.session_id);
//         setSessionId(data.session_id);
//       }

//       const botMessage = parsePricesToTables(
//         data.answer || "",
//         data.product_url,
//         data.image_url   // ✅ PASS IMAGE HERE
//       );

//       setChat(prev => [...prev, botMessage]);

//     } catch (err) {
//       setChat(prev => [
//         ...prev,
//         { role: "bot", text: "Server error. Please try again." }
//       ]);
//     }

//     setQuestion("");
//     setLoading(false);
//   };

//   const startNewChat = () => {
//     localStorage.removeItem("session_id");
//     setSessionId(null);
//     setChat([]);
//   };

//   // ============================================
//   // 🔥 PRICE → TABLE PARSER
//   // ============================================
//   const parsePricesToTables = (text, product_url = null, image_url = null) => {
//     const tables = [];
//     const tableRows = [];
//     const addedRows = new Set();

//     const durationRegex =
//       /(\d+\s*-?\s*(Hour|Hours|Cup|Cups))[^$\d]*\$?([\d]+(?:\.\d+)?)/gi;

//     let match;
//     while ((match = durationRegex.exec(text)) !== null) {
//       const duration = match[1].trim();
//       const price = match[3].trim();
//       const key = duration + price;

//       if (!addedRows.has(key)) {
//         tableRows.push({ Duration: duration, Price: price });
//         addedRows.add(key);
//       }
//     }

//     const addonRegex =
//       /addon\s+(?:quantity|price)[^$\d]*\$?([\d]+(?:\.\d+)?)/i;

//     const addonMatch = text.match(addonRegex);

//     if (addonMatch) {
//       const price = addonMatch[1].trim();
//       const key = "Addon" + price;

//       if (!addedRows.has(key)) {
//         tableRows.push({ Duration: "Addon Quantity", Price: price });
//         addedRows.add(key);
//       }
//     }

//     const simplePriceRegex =
//       /\bis\s+\$?([\d]+(?:\.\d+)?)/gi;

//     while ((match = simplePriceRegex.exec(text)) !== null) {
//       const price = match[1].trim();
//       const key = "Standard" + price;

//       if (!addedRows.has(key) && tableRows.length === 0) {
//         tableRows.push({ Duration: "Standard", Price: price });
//         addedRows.add(key);
//       }
//     }

//     if (tableRows.length) tables.push(tableRows);

//     return {
//       role: "bot",
//       text,
//       tables: tables.length ? tables : null,
//       product_url,
//       image_url  // ✅ SAVE IMAGE
//     };
//   };

//   return (
//     <div className="app-container">
//       <div className="chat-card">

//         {/* Header */}
//         <div className="chat-header">
//           <img
//             src="/3ab1a470-526e-41c6-b105-c495834803c6.png"
//             alt="Aiyo Logo"
//             className="logo"
//           />
//           <h2>Aiyo Event AI Assistant</h2>
//         </div>

//         {/* Chat Body */}
//         <div className="chat-body">
//           {chat.map((msg, index) => (
//             <div
//               key={index}
//               className={
//                 msg.role === "user"
//                   ? "user-message"
//                   : "bot-message"
//               }
//             >
//               <div>{msg.text}</div>

//               {/* ✅ PRODUCT IMAGE DISPLAY */}
//               {msg.image_url && (
//                 <div className="product-image-container">
//                   <img
//                     src={msg.image_url}
//                     alt="Product"
//                     className="product-image"
//                   />
//                 </div>
//               )}

//               {/* Dynamic Tables */}
//               {msg.tables &&
//                 msg.tables.map((table, tIndex) => (
//                   <table key={tIndex} className="chat-table">
//                     <thead>
//                       <tr>
//                         {Object.keys(table[0]).map((key, i) => (
//                           <th key={i}>{key}</th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {table.map((row, rIndex) => (
//                         <tr key={rIndex}>
//                           {Object.values(row).map((val, cIndex) => (
//                             <td key={cIndex}>{val}</td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 ))}

//               {/* Product Link */}
//               {msg.product_url && (
//                 <a
//                   href={msg.product_url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="buy-button"
//                 >
//                   View / Buy Now
//                 </a>
//               )}
//             </div>
//           ))}

//           {loading && (
//             <div className="bot-message typing">
//               Typing...
//             </div>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="chat-footer">
//           <input
//             value={question}
//             onChange={(e) => setQuestion(e.target.value)}
//             placeholder="Ask about products..."
//             onKeyDown={(e) =>
//               e.key === "Enter" && sendMessage()
//             }
//           />
//           <button onClick={sendMessage}>
//             Send
//           </button>
//         </div>

//       </div>
//     </div>
//   );
// }

// export default App;



// old@@@@@@@@@@@ RAMMMMMMMMMMM




// import React, { useState, useEffect } from "react";
// import "./App.css";

// function App() {
//   const [question, setQuestion] = useState("");
//   const [chat, setChat] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [sessionId, setSessionId] = useState(null);

//   // Load session
//   useEffect(() => {
//     const storedSession = localStorage.getItem("session_id");
//     if (storedSession) setSessionId(storedSession);
//   }, []);

//   const sendMessage = async () => {
//     if (!question.trim()) return;

//     const userMessage = { role: "user", text: question };
//     setChat(prev => [...prev, userMessage]);
//     setLoading(true);

//     try {
//       const response = await fetch("http://localhost:9000/chat", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ question, session_id: sessionId })
//       });

//       const data = await response.json();

//       if (data.session_id) {
//         localStorage.setItem("session_id", data.session_id);
//         setSessionId(data.session_id);
//       }

//       const botMessage = parsePricesToTables(
//         data.answer || "",
//         data.product_url,
//         data.image_url
//       );

//       setChat(prev => [...prev, botMessage]);

//     } catch (err) {
//       setChat(prev => [
//         ...prev,
//         { role: "bot", text: "Server error. Please try again." }
//       ]);
//     }

//     setQuestion("");
//     setLoading(false);
//   };

//   const startNewChat = () => {
//     localStorage.removeItem("session_id");
//     setSessionId(null);
//     setChat([]);
//   };

//   // ====================================================
//   // 🔥 UPDATED PRICE PARSER (WITH DISCOUNT SUPPORT)
//   // ====================================================
//   const parsePricesToTables = (text, product_url = null, image_url = null) => {
//     const tables = [];
//     const tableRows = [];
//     const addedRows = new Set();

//     let match;

//     // =========================
//     // 1️⃣ DISCOUNT FORMAT
//     // =========================
//     const discountRegex =
//       /(\d+\s*-?\s*(Hour|Hours|Cup|Cups)).*?Original Price:\s*\$?([\d.]+).*?Discount:\s*(\d+%).*?Discounted Price:\s*\$?([\d.]+)/gis;

//     while ((match = discountRegex.exec(text)) !== null) {
//       const duration = match[1].trim();
//       const originalPrice = match[3].trim();
//       const discount = match[4].trim();
//       const discountedPrice = match[5].trim();

//       const key = duration + originalPrice + discountedPrice;

//       if (!addedRows.has(key)) {
//         tableRows.push({
//           Duration: duration,
//           "Original Price": `$${originalPrice}`,
//           Discount: discount,
//           "Discounted Price": `$${discountedPrice}`
//         });
//         addedRows.add(key);
//       }
//     }

//     // =========================
//     // 2️⃣ NORMAL PRICE (NO DISCOUNT)
//     // =========================
//     if (tableRows.length === 0) {
//       const normalRegex =
//         /(\d+\s*-?\s*(Hour|Hours|Cup|Cups))[^$\d]*\$?([\d]+(?:\.\d+)?)/gi;

//       while ((match = normalRegex.exec(text)) !== null) {
//         const duration = match[1].trim();
//         const price = match[3].trim();
//         const key = duration + price;

//         if (!addedRows.has(key)) {
//           tableRows.push({
//             Duration: duration,
//             "Original Price": `$${price}`,
//             Discount: "No Discount",
//             "Discounted Price": `$${price}`
//           });
//           addedRows.add(key);
//         }
//       }
//     }

//     if (tableRows.length) tables.push(tableRows);

//     return {
//       role: "bot",
//       text,
//       tables: tables.length ? tables : null,
//       product_url,
//       image_url
//     };
//   };

//   return (
//     <div className="app-container">
//       <div className="chat-card">

//         {/* Header */}
//         <div className="chat-header">
//           <img
//             src="/3ab1a470-526e-41c6-b105-c495834803c6.png"
//             alt="Aiyo Logo"
//             className="logo"
//           />
//           <h2>Aiyo Event AI Assistant</h2>
//         </div>

//         {/* Chat Body */}
//         <div className="chat-body">
//           {chat.map((msg, index) => (
//             <div
//               key={index}
//               className={
//                 msg.role === "user"
//                   ? "user-message"
//                   : "bot-message"
//               }
//             >
//               <div>{msg.text}</div>

//               {/* Product Image */}
//               {msg.image_url && (
//                 <div className="product-image-container">
//                   <img
//                     src={msg.image_url}
//                     alt="Product"
//                     className="product-image"
//                   />
//                 </div>
//               )}

//               {/* Dynamic Tables */}
//               {msg.tables &&
//                 msg.tables.map((table, tIndex) => (
//                   <table key={tIndex} className="chat-table">
//                     <thead>
//                       <tr>
//                         {Object.keys(table[0]).map((key, i) => (
//                           <th key={i}>{key}</th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {table.map((row, rIndex) => (
//                         <tr key={rIndex}>
//                           {Object.values(row).map((val, cIndex) => (
//                             <td key={cIndex}>{val}</td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 ))}

//               {/* Product Link */}
//               {msg.product_url && (
//                 <a
//                   href={msg.product_url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="buy-button"
//                 >
//                   View / Buy Now
//                 </a>
//               )}
//             </div>
//           ))}

//           {loading && (
//             <div className="bot-message typing">
//               Typing...
//             </div>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="chat-footer">
//           <input
//             value={question}
//             onChange={(e) => setQuestion(e.target.value)}
//             placeholder="Ask about products..."
//             onKeyDown={(e) =>
//               e.key === "Enter" && sendMessage()
//             }
//           />
//           <button onClick={sendMessage}>
//             Send
//           </button>
//         </div>

//       </div>
//     </div>
//   );
// }

// export default App;


// RAMMMMMMMMMMMMMMM==========

// import React, { useState, useEffect, useRef } from "react";
// import "./App.css";

// // --- FORMATTING FUNCTION ---
// const formatMessageText = (text) => {
//   if (!text) return null;
//   const textWithNewlines = text.replace(/ (?=\d+\.\s)/g, '\n');
//   const lines = textWithNewlines.split('\n');

//   return lines.map((line, lineIndex) => {
//     const parts = line.split(/(\*\*.*?\*\*)/g);
//     return (
//       <div key={lineIndex} style={{ marginBottom: line.trim() ? "8px" : "0px", lineHeight: "1.5" }}>
//         {parts.map((part, i) => {
//           if (part.startsWith('**') && part.endsWith('**')) {
//             return <strong key={i}>{part.substring(2, part.length - 2)}</strong>;
//           }
//           return <span key={i}>{part}</span>;
//         })}
//       </div>
//     );
//   });
// };

// function App() {
//   const [question, setQuestion] = useState("");
//   const [chat, setChat] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [sessionId, setSessionId] = useState(null);
//   const [showBookingButtons, setShowBookingButtons] = useState(false);
//   const [bookingStep, setBookingStep] = useState(null);

//   const inputRef = useRef(null);
//   const chatEndRef = useRef(null);

//   // Auto-scroll to bottom when chat updates
//   useEffect(() => {
//     chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [chat, loading]);

//   useEffect(() => {
//     const storedSession = localStorage.getItem("session_id");
//     if (storedSession) setSessionId(storedSession);

//     setChat([
//       {
//         role: "bot",
//         text: "👋 Welcome to Aiyo Event Chatbot! How can I help you today?"
//       }
//     ]);
//   }, []);

//   // Force cursor focus back to input whenever loading finishes or booking buttons hide
//   useEffect(() => {
//     if (!showBookingButtons && !loading) {
//       inputRef.current?.focus();
//     }
//   }, [showBookingButtons, loading]);

//   const sendMessage = async (userText) => {
//     if (!userText.trim()) return;

//     setChat(prev => [...prev, { role: "user", text: userText }]);
//     setLoading(true);

//     try {
//       // const response = await fetch("https://aiyochat.diyesh.com/api/chat", {

//       const response = await fetch("http://localhost:5000/api/chat", {

//       // const response = await fetch("https://aiyochat.diyesh.com/api/chat", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           question: userText,
//           session_id: sessionId
//         }) 
//       });

//       const data = await response.json();

//       if (data.session_id) {
//         localStorage.setItem("session_id", data.session_id);
//         setSessionId(data.session_id);
//       }

//       const botMessage = parsePricesToTables(
//         data.answer || "I'm sorry, I couldn't find that information.",
//         data.product_url,
//         data.image_url
//       );

//       setChat(prev => [...prev, botMessage]);

//       if (data.show_booking_option) {
//         setShowBookingButtons(true);
//       }
//     } catch (error) {
//       setChat(prev => [
//         ...prev,
//         { role: "bot", text: "⚠️ Connection error. Please check your backend." }
//       ]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleBookingInput = async (value) => {
//     setLoading(true);
//     try {

//       const res = await fetch("http://localhost:5000/api/booking", {

//         // const res = await fetch("https://aiyochat.diyesh.com/api/booking", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ session_id: sessionId, value })
//       });

//       const data = await res.json();
      
//       if (data.success) {
//         setChat(prev => [...prev, { role: "bot", text: "✅ Event booked successfully!" }]);
//         setBookingStep(null);
//       } else {
//         setChat(prev => [...prev, { role: "bot", text: data.question }]);
//         const q = data.question.toLowerCase();
//         if (q.includes("name")) setBookingStep("name");
//         else if (q.includes("phone")) setBookingStep("phone");
//         else if (q.includes("email")) setBookingStep("email");
//       }
//     } catch {
//       alert("Booking system error.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleInputSubmit = () => {
//     if (loading || !question.trim()) return;

//     const currentInput = question.trim();
//     setQuestion(""); // Immediate UI clear

//     if (bookingStep) {
//       setChat(prev => [...prev, { role: "user", text: currentInput }]);
//       handleBookingInput(currentInput);
//     } else {
//       sendMessage(currentInput);
//     }
//   };

//   const parsePricesToTables = (text, product_url = null, image_url = null) => {
//     const tables = [];
//     const tableRows = [];
//     const addedRows = new Set();
//     let match;

//     const discountRegex = /((?:\d+\s*-?\s*(?:Hour|Hours|Cup|Cups))|(?:Addon\s*(?:Hr|Qty))).*?Original Price:\s*\$?([\d.]+)(?:.*?Discount:\s*(\d+%).*?Discounted Price:\s*\$?([\d.]+))?/gis;

//     while ((match = discountRegex.exec(text)) !== null) {
//       const duration = match[1].trim();
//       const originalPrice = match[2].trim();
//       const discount = match[3] ? match[3].trim() : "No Discount";
//       const discountedPrice = match[4] ? match[4].trim() : originalPrice;
//       const key = duration + originalPrice + discountedPrice;
//       if (!addedRows.has(key)) {
//         tableRows.push({ Duration: duration, "Original Price": `$${originalPrice}`, Discount: discount, "Discounted Price": `$${discountedPrice}` });
//         addedRows.add(key);
//       }
//     }

//     if (tableRows.length === 0) {
//       const normalRegex = /(\d+\s*-?\s*(Hour|Hours|Cup|Cups))[^$\d]*\$?([\d]+(?:\.\d+)?)/gi;
//       while ((match = normalRegex.exec(text)) !== null) {
//         const duration = match[1].trim();
//         const price = match[3].trim();
//         const key = duration + price;
//         if (!addedRows.has(key)) {
//           tableRows.push({ Duration: duration, "Original Price": `$${price}`, Discount: "No Discount", "Discounted Price": `$${price}` });
//           addedRows.add(key);
//         }
//       }
//     }

//     if (tableRows.length) tables.push(tableRows);
//     return { role: "bot", text, tables: tables.length ? tables : null, product_url, image_url };
//   };

//   return (
//     <div className="app-container">
//       <div className="chat-card">
//         <div className="chat-header">
//           <img src="/3ab1a470-526e-41c6-b105-c495834803c6.png" alt="Aiyo Logo" className="logo" />
//           <h2>Aiyo Event AI Assistant</h2>
//         </div>

//         <div className="chat-body">
//           {chat.map((msg, index) => (
//             <div key={index} className={msg.role === "user" ? "user-message" : "bot-message"}>
//               {/* {!msg.tables && formatMessageText(msg.text)} */}
// {msg.tables
//   ? formatMessageText(msg.text.split("\n")[0])   // show only title for products
//   : formatMessageText(msg.text)                  // show full paragraph for normal questions
// }              {msg.image_url && (
//                 <div className="product-image-container">
//                   <img src={msg.image_url} alt="Product" className="product-image" />
//                 </div>
//               )}
//               {msg.tables && msg.tables.map((table, tIndex) => (
//                 <table key={tIndex} className="chat-table">
//                   <thead>
//                     <tr>{Object.keys(table[0]).map((key, i) => <th key={i}>{key}</th>)}</tr>
//                   </thead>
//                   <tbody>
//                     {table.map((row, rIndex) => (
//                       <tr key={rIndex}>{Object.values(row).map((val, cIndex) => <td key={cIndex}>{val}</td>)}</tr>
//                     ))}
//                   </tbody>
//                 </table>
//               ))}
//               {msg.product_url && (
//                 <a href={msg.product_url} target="_blank" rel="noopener noreferrer" className="buy-button">View / Buy Now</a>
//               )}
//             </div>
//           ))}

//           {showBookingButtons && (
//             <div className="bot-message">
//               <div>Are you booking this event?</div>
//               <button className="option-btn" onClick={() => { setShowBookingButtons(false); setBookingStep("date"); setChat(prev => [...prev, {role: "bot", text: "Please enter Event Date (DD/MM/YYYY)"}]); }}>YES</button>
//               <button className="option-btn" onClick={() => setShowBookingButtons(false)}>NO</button>
//             </div>
//           )}

//           {/* {loading && (
//             <div className="bot-message typing">
//               <span>🤖 AI is thinking...</span>
//             </div>
//           )} */}
//           {loading && (
//   <div className="bot-message typing">
//     {bookingStep ? "📅 Email sending popup is waiting..." : "🤖 AI is thinking..."}
//   </div>
//   )}


//           <div ref={chatEndRef} />
//         </div>

//         <div className="chat-footer">
//           <input
//             ref={inputRef}
//             value={question}
//             onChange={(e) => setQuestion(e.target.value)}
//             placeholder="Ask anything about your event..."
//             // ✅ CHANGE: Using readOnly instead of disabled keeps the cursor blinking
//             readOnly={loading} 
//             onKeyDown={(e) => e.key === "Enter" && handleInputSubmit()}
//             style={{ cursor: loading ? "not-allowed" : "text" }}
//           />
//           <button onClick={handleInputSubmit} disabled={loading || !question.trim()}>
//             Send
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default App;

// ============


import React, { useState, useEffect, useRef } from "react";
import "./App.css";

// --- FORMATTING FUNCTION ---
const formatMessageText = (text) => {
  if (!text) return null;
  const textWithNewlines = text.replace(/ (?=\d+\.\s)/g, '\n');
  const lines = textWithNewlines.split('\n');

  return lines.map((line, lineIndex) => {
    const parts = line.split(/(\*\*.*?\*\*)/g);
    return (
      <div key={lineIndex} style={{ marginBottom: line.trim() ? "8px" : "0px", lineHeight: "1.5" }}>
        {parts.map((part, i) => {
          if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={i}>{part.substring(2, part.length - 2)}</strong>;
          }
          return <span key={i}>{part}</span>;
        })}
      </div>
    );
  });
};

function App() {
  const [question, setQuestion] = useState("");
  const [chat, setChat] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [showBookingButtons, setShowBookingButtons] = useState(false);
  const [bookingStep, setBookingStep] = useState(null);
  const [listening, setListening] = useState(false);
  const startVoice = () => {
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;

  if (!SpeechRecognition) {
    alert("Voice not supported in this browser");
    return;
  }

  const recognition = new SpeechRecognition();
  recognition.lang = "en-US";

  recognition.onstart = () => setListening(true);

  recognition.onresult = (event) => {
    const voiceText = event.results[0][0].transcript;
    setQuestion(voiceText);

    // 🔥 Auto send message
    sendMessage(voiceText);
  };

  recognition.onend = () => setListening(false);

  recognition.start();
};

  const inputRef = useRef(null);
  const chatEndRef = useRef(null);

  // Auto-scroll to bottom when chat updates
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chat, loading]);

  useEffect(() => {
    const storedSession = localStorage.getItem("session_id");
    if (storedSession) setSessionId(storedSession);

    setChat([
      {
        role: "bot",
        text: "👋 Welcome to Aiyo Event Chatbot! How can I help you today?"
      }
    ]);
  }, []);

  // Force cursor focus back to input whenever loading finishes or booking buttons hide
  useEffect(() => {
    if (!showBookingButtons && !loading) {
      inputRef.current?.focus();
    }
  }, [showBookingButtons, loading]);

  const sendMessage = async (userText) => {
    if (!userText.trim()) return;

    setChat(prev => [...prev, { role: "user", text: userText }]);
    setLoading(true);

    try {
      // const response = await fetch("https://aiyochat.diyesh.com/api/chat", {

      // const response = await fetch("http://localhost:5000/api/chat", {

      const response = await fetch("https://aiyochat.diyesh.com/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          question: userText,
          session_id: sessionId
        }) 
      });

      const data = await response.json();

      if (data.session_id) {
        localStorage.setItem("session_id", data.session_id);
        setSessionId(data.session_id);
      }

      const botMessage = parsePricesToTables(
        data.answer || "I'm sorry, I couldn't find that information.",
        data.product_url,
        data.image_url
      );

      setChat(prev => [...prev, botMessage]);

      if (data.show_booking_option) {
        setShowBookingButtons(true);
      }
    } catch (error) {
      setChat(prev => [
        ...prev,
        { role: "bot", text: "⚠️ Connection error. Please check your backend." }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleBookingInput = async (value) => {
    setLoading(true);
    try {

      // const res = await fetch("http://localhost:5000/api/booking", {

        const res = await fetch("https://aiyochat.diyesh.com/api/booking", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId, value })
      });

      const data = await res.json();
      
      if (data.success) {
        setChat(prev => [...prev, { role: "bot", text: "✅ Event booked successfully!" }]);
        setBookingStep(null);
      } else {
        setChat(prev => [...prev, { role: "bot", text: data.question }]);
        const q = data.question.toLowerCase();
        if (q.includes("name")) setBookingStep("name");
        else if (q.includes("phone")) setBookingStep("phone");
        else if (q.includes("email")) setBookingStep("email");
      }
    } catch {
      alert("Booking system error.");
    } finally {
      setLoading(false);
    }
  };

  const handleInputSubmit = () => {
    if (loading || !question.trim()) return;

    const currentInput = question.trim();
    setQuestion(""); // Immediate UI clear

    if (bookingStep) {
      setChat(prev => [...prev, { role: "user", text: currentInput }]);
      handleBookingInput(currentInput);
    } else {
      sendMessage(currentInput);
    }
  };

  const parsePricesToTables = (text, product_url = null, image_url = null) => {
    const tables = [];
    const tableRows = [];
    const addedRows = new Set();
    let match;

    const discountRegex = /((?:\d+\s*-?\s*(?:Hour|Hours|Cup|Cups))|(?:Addon\s*(?:Hr|Qty))).*?Original Price:\s*\$?([\d.]+)(?:.*?Discount:\s*(\d+%).*?Discounted Price:\s*\$?([\d.]+))?/gis;

    while ((match = discountRegex.exec(text)) !== null) {
      const duration = match[1].trim();
      const originalPrice = match[2].trim();
      const discount = match[3] ? match[3].trim() : "No Discount";
      const discountedPrice = match[4] ? match[4].trim() : originalPrice;
      const key = duration + originalPrice + discountedPrice;
      if (!addedRows.has(key)) {
        tableRows.push({ Duration: duration, "Original Price": `$${originalPrice}`, Discount: discount, "Discounted Price": `$${discountedPrice}` });
        addedRows.add(key);
      }
    }

    if (tableRows.length === 0) {
      const normalRegex = /(\d+\s*-?\s*(Hour|Hours|Cup|Cups))[^$\d]*\$?([\d]+(?:\.\d+)?)/gi;
      while ((match = normalRegex.exec(text)) !== null) {
        const duration = match[1].trim();
        const price = match[3].trim();
        const key = duration + price;
        if (!addedRows.has(key)) {
          tableRows.push({ Duration: duration, "Original Price": `$${price}`, Discount: "No Discount", "Discounted Price": `$${price}` });
          addedRows.add(key);
        }
      }
    }

    if (tableRows.length) tables.push(tableRows);
    return { role: "bot", text, tables: tables.length ? tables : null, product_url, image_url };
  };

  return (
    <div className="app-container">
      <div className="chat-card">
        <div className="chat-header">
          <img src="/3ab1a470-526e-41c6-b105-c495834803c6.png" alt="Aiyo Logo" className="logo" />
          <h2>Aiyo Event AI Assistant</h2>
        </div>

        <div className="chat-body">
          {chat.map((msg, index) => (
            <div key={index} className={msg.role === "user" ? "user-message" : "bot-message"}>
              {/* {!msg.tables && formatMessageText(msg.text)} */}
{msg.tables
  ? formatMessageText(msg.text.split("\n")[0])   // show only title for products
  : formatMessageText(msg.text)                  // show full paragraph for normal questions
}              {msg.image_url && (
                <div className="product-image-container">
                  <img src={msg.image_url} alt="Product" className="product-image" />
                </div>
              )}
              {msg.tables && msg.tables.map((table, tIndex) => (
                <table key={tIndex} className="chat-table">
                  <thead>
                    <tr>{Object.keys(table[0]).map((key, i) => <th key={i}>{key}</th>)}</tr>
                  </thead>
                  <tbody>
                    {table.map((row, rIndex) => (
                      <tr key={rIndex}>{Object.values(row).map((val, cIndex) => <td key={cIndex}>{val}</td>)}</tr>
                    ))}
                  </tbody>
                </table>
              ))}
              {msg.product_url && (
                <a href={msg.product_url} target="_blank" rel="noopener noreferrer" className="buy-button">View / Buy Now</a>
              )}
            </div>
          ))}

          {showBookingButtons && (
            <div className="bot-message">
              <div>Are you booking this event?</div>
              <button className="option-btn" onClick={() => { setShowBookingButtons(false); setBookingStep("date"); setChat(prev => [...prev, {role: "bot", text: "Please enter Event Date (DD/MM/YYYY)"}]); }}>✅ YES</button>
              <button className="option-btn" onClick={() => setShowBookingButtons(false)}>❌ NO</button>
            </div>
          )}

          {/* {loading && (
            <div className="bot-message typing">
              <span>🤖 AI is thinking...</span>
            </div>
          )} */}
          {loading && (
  <div className="bot-message typing">
    {bookingStep ? "📅 Email sending popup is waiting..." : "🤖 AI is thinking..."}
  </div>
  )}


          <div ref={chatEndRef} />
        </div>

        <div className="chat-footer">
          <input
            ref={inputRef}
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Ask about products..."
            // ✅ CHANGE: Using readOnly instead of disabled keeps the cursor blinking
            readOnly={loading} 
            onKeyDown={(e) => e.key === "Enter" && handleInputSubmit()}
            style={{ cursor: loading ? "not-allowed" : "text" }}
          />
         {/* 🎤 VOICE BUTTON */}
<button
  onClick={startVoice}
  className={listening ? "voice-btn active" : "voice-btn"}
>
  {listening ? "🎙️" : "🎤"}
</button>

<button onClick={handleInputSubmit} disabled={loading || !question.trim()}>
  Send
</button>
        </div>
      </div>
    </div>
  );
}

export default App;